import Player from "video.js/dist/types/player";

import { getVideoJsComponent } from "./utils";

import type { THEOPlayerRuntime } from "./theoplayerRuntime";

export const getOverlayPlayIcon = (runtime: THEOPlayerRuntime) => {
  const VideoJSComponent = getVideoJsComponent("Component", runtime);

  class OverlayPlayIcon extends VideoJSComponent {
    constructor(player: Player, options = {}) {
      super(player, options);
    }

    createEl() {
      const playIcon = `
      <svg width="17" height="22" viewBox="0 0 17 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M-0.00683594 0.49332V21.5067L16.5066 11L-0.00683594 0.49332Z" fill="white"/>
      </svg>
    `;

      const el = super.createEl("div", {
        className: "vjs-custom-overlay-icon vjs-custom-overlay-play-icon",
        innerHTML: `${playIcon}`,
      });
      return el;
    }
  }

  return OverlayPlayIcon;
};

export const getOverlayPauseIcon = (runtime: THEOPlayerRuntime) => {
  const VideoJSComponent = getVideoJsComponent("Component", runtime);

  class OverlayPauseIcon extends VideoJSComponent {
    constructor(player: Player, options = {}) {
      super(player, options);
    }

    createEl() {
      const pauseIcon = `
      <svg width="18" height="22" viewBox="0 0 18 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0 21.5067H6.0067V0.493305H0V21.5067ZM11.9933 0.493305V21.5067H18V0.493305H11.9933Z" fill="white"/>
      </svg>
    `;

      const el = super.createEl("div", {
        className: "vjs-custom-overlay-icon vjs-custom-overlay-pause-icon",
        innerHTML: `${pauseIcon}`,
      });
      return el;
    }
  }

  return OverlayPauseIcon;
};
